import React from 'react';

import loading from '../../assets/loading/tres_pontos.gif';

import { Container } from './styles';

const Loading: React.FC = () => {
  return (
    <Container>
      <img src={loading} alt="loading" />
    </Container>
  );
};

export default Loading;
